import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const FixedCta = ({ buttonText , color , variant , url , newWindow =false , icon , description ,  })=>{
    // component is rendered twice - to display the cta-button and to add cta-button-placeholder to the page-dom
    //  as spacing was required between the page-footer and the cta-button
    const CtaButtonComponent = /*#__PURE__*/ React.createElement("div", {
        className: "fixed-cta-button__wrapper"
    }, /*#__PURE__*/ React.createElement(Button, {
        caption: buttonText,
        color: color,
        variant: variant,
        size: "medium",
        href: url,
        hrefTarget: newWindow ? '_blank' : undefined,
        icon: icon
    }), description && /*#__PURE__*/ React.createElement("span", {
        className: "fixed-cta-button__description"
    }, description));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "fixed-cta-button"
    }, CtaButtonComponent), /*#__PURE__*/ React.createElement("div", {
        className: "fixed-cta-button fixed-cta-button__placeholder",
        "aria-hidden": "true"
    }, CtaButtonComponent));
};

export { FixedCta as default };
//# sourceMappingURL=FixedCta.js.map
